import type { Locale } from '@/utils/localeFormatters';

export type FractionDigits = Pick<
    Intl.NumberFormatOptions,
    'minimumFractionDigits' | 'maximumFractionDigits'
>;

/**
 * A number in the dashboard locale (U3), grouped from four digits in every language. Intl
 * groups es only from five digits ("3208"), while the portal's chart axes always group it
 * ("3.400 g"), so a card beside an axis would print the same kind of figure two ways.
 */
export function formatDashboardNumber(
    value: number,
    locale: Locale,
    digits: FractionDigits
): string {
    // Under Intl.NumberFormat v3 `true` means "always", where leaving it out means "auto",
    // the locale's own minimum. The TypeScript lib here types the option as boolean only.
    return value.toLocaleString(locale, { ...digits, useGrouping: true });
}
